import React from "react";
import { useSelector } from "react-redux";
import Loader from "../../Loader";
import { decodeHtml } from "../../components/util";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Process = () => {
  const { page } = useSelector((state) => state.data);
  const history = useHistory();

  const handleClick = (e) => {
    const contactBtn = e.target.closest("a.learn-more");

    if (contactBtn) {
      e.preventDefault();
      history.push("/contact");
      window.scrollTo(0, 0);
    }
  };

  if (!page || !page.data) return <Loader />;

  const htmlContent = decodeHtml(
    page.data["process-section"]?.htmlContent || ""
  );

  return (
    <div className="rs-process pt-180 pb-120 md-pt-70 md-pb-70 padding-150">
      <div className="container">
        {htmlContent ? (
          <div
            id="html-container"
            onClick={handleClick}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        ) : (
          <p>No content found for Process section.</p>
        )}
      </div>
    </div>
  );
};

export default Process;
